module.exports = __webpack_public_path__ + "static/img/W.059c438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/W.png
// module id = F/0y
// module chunks = 0